<template>
  <div class="remove-confirm-modal">
    <CustomModal @onClose="close(true)">
      <div class="remove-confirm-modal-content-wrapper">
        <div v-if="isLoading" class="loading-wrapper">
          <LoadingSpinner />
        </div>

        <div class="content" v-if="!isLoading">
          <h3
            class="content-title pre-wrap"
            v-html="text[resourceType][actionType].title"
          ></h3>

          <div class="warning-message-container" v-if="actionType === 'remove'">
            <p
              class="content-paragraph"
              v-if="text[resourceType][actionType].paragraph"
            >
              <span
                ><img
                  :src="require('../../assets/img/circle-exclamation.svg')"
                />
              </span>
              <span
                class="content-paragraph-text"
                v-html="text[resourceType][actionType].paragraph"
              />
            </p>

            <div v-if="isWarningVisible" class="content-warning">
              <p class="public-warning" v-if="getWFlowWarningInfo.isPublic">
                <span class="warning-icon"> ⚠️ </span>
                <span>
                  {{ text[resourceType][actionType].warning.public }}</span
                >
              </p>
              <p
                class="shared-with-other-warning"
                v-if="getWFlowWarningInfo.isSharedWithOthers"
              >
                <span class="warning-icon"> ⚠️ </span>
                <span>
                  {{
                    text[resourceType][actionType].warning.sharedWithOthers
                  }}</span
                >
              </p>
            </div>
          </div>

          <p
            class="content-description pre-wrap"
            v-html="text[resourceType][actionType].description"
          ></p>

          <div v-if="selectedItems?.length" class="record-list">
            <h2>Ausgewählte Einträge</h2>
            <ul>
              <li
                v-for="item in selectedItems"
                :key="item.id"
                @click="onOpenItemView(item.id)"
              >
                <img :src="require('../../assets/img/file-icon.svg')" />
                <span>{{ item.name || item.id }}</span>
                <img
                  :src="require('../../assets/img/url-link-icon.svg')"
                  class="link-icon"
                />
              </li>
            </ul>
          </div>

          <form @submit.prevent="confirm()">
            <input
              :placeholder="name"
              v-model="confirmMessage"
              type="text"
              required
              class="confirmation-message-input"
            />
            <CommonButton
              class="common-button-component"
              onClick="confirm"
              :isLoading="isLoadingButton"
              :isDisabled="
                getCleanString(confirmMessage) != getCleanString(name)
              "
            >
              {{ getDeleteButtonText }}
            </CommonButton>
          </form>
        </div>
      </div>
    </CustomModal>
  </div>
</template>
<script>
import CustomModal from './CustomModal.vue';
import CommonButton from '../widgets/CommonButton.vue';

import { getWorkFlowAccessRights } from '@/services/workflow.service';
import LoadingSpinner from '../widgets/LoadingSpinner.vue';

export default {
  name: 'RemoveConfirmModal',
  props: {
    id: {
      type: String,
      required: false,
    },
    name: {
      type: String,
      required: true,
    },
    resourceType: {
      type: String,
      required: true,
    },
    actionType: {
      type: String,
      required: true,
    },
    flows: {
      type: Array,
      required: false,
      default: () => [],
    },
    itemsCount: {
      type: Number,
      required: false,
      default: 0,
    },
    selectedItems: {
      type: Array,
      required: false,
      default: () => [],
    },
    isLoadingButton: {
      type: Boolean,
      default: false,
    },
    databaseName: String,
  },
  data() {
    return {
      confirmMessage: '',
      text: {
        flow: {
          leave: {
            title: 'Flow <b>' + this.name + '</b> verlassen',
            paragraph: '',
            description:
              'Bitte geben Sie im untenstehenden Feld den Namen des zu verlassenden Flows <b>' +
              this.name +
              '</b> ein.',
          },
          remove: {
            title: this.flows.length
              ? 'Mehrere Workflows löschen'
              : 'Flow <b>' + this.name + '</b> löschen',
            paragraph: 'Gelöschte Flows können nicht wiederhergestellt werden.',
            description: this.flows.length
              ? 'Bitte geben Sie im untenstehenden Feld <b>Mehrere Workflows löschen</b> ein, um die ausgewählten Flows endgültig zu löschen.'
              : 'Bitte geben Sie im untenstehenden Feld den Namen des zu löschenden Flows <b>' +
                this.name +
                '</b> ein um den Flow endgültig zu löschen.',
            warning: {
              public:
                ' Der Workflow ist öffentlich. Bitte stellen Sie sicher, dass der Workflow nicht auf einer öffentlichen Webseite verwendet wird',
              sharedWithOthers: this.flows.length
                ? 'Einer der ausgewählten Flows wurde mit anderen Benutzern geteilt. Wenn Sie den Flow löschen, wird er für alle Benutzer gelöscht.'
                : 'Der Flow wurde mit anderen Benutzern geteilt. Wenn Sie den Flow löschen, wird er für alle Benutzer gelöscht',
            },
          },
        },
        flows: {
          remove: {
            title: 'Flow',
            paragraph: 'Gelöschte Flows können nicht wiederhergestellt werden',
            description: `Dis  bar`,
          },
        },
        database: {
          leave: {
            title: 'Datenbank <b>' + this.name + '</b> verlassen',
            paragraph: '',
            description:
              'Bitte geben Sie im untenstehenden Feld den Namen der zu verlassenden Datenbank <b>' +
              this.name +
              '</b> ein.',
          },
          remove: {
            title: 'Datenbank <b>' + this.name + '</b> löschen',
            paragraph:
              'Gelöschte Datenbanken können nicht wiederhergestellt werden',
            description:
              'Bitte geben Sie im untenstehenden Feld den Namen der zu löschenden Datenbank <b>' +
              this.name +
              '</b> ein um die Datenbank endgültig zu löschen.',
          },
        },
        item: {
          remove: {
            title: 'Eintrag löschen',
            paragraph:
              'Gelöschte Elemente können nicht wiederhergestellt werden',
            description:
              'Bitte geben Sie <b>' +
              this.name +
              '</b> im untenstehenden Feld ein, um den ausgewählten Eintrag zu löschen.',
          },
        },
      },

      selectedRemoveFlowPolicy: [],
      isLoading: false,
    };
  },
  methods: {
    close(bool) {
      this.$emit('close', bool);
    },
    confirm() {
      if (this.actionType == 'leave') {
        this.$emit('confirmLeave', this.id);
      } else if (this.actionType == 'remove' && !this.flows?.length) {
        this.$emit('confirmRemove', this.id);
      } else if (this.actionType == 'remove' && this.flows.length) {
        this.$emit('confirmRemove', this.flows);
      }
      this.close(false);
    },
    getCleanString(value) {
      try {
        // Remove non-printable-chars and emojis
        // eslint-disable-next-line no-control-regex
        value = value.replace(/[^\x00-\x7F]/g, ' ').trim();
      } catch {
        /*Nothing*/
      }
      return value;
    },

    async getWorkflowPolicies() {
      try {
        if (!this.flows.length) {
          this.isLoading = true;
          const flowPolicies = await getWorkFlowAccessRights(this.id);

          this.selectedRemoveFlowPolicy = flowPolicies.data;
        } else {
          this.isLoading = true;
          for (let flow of this.flows) {
            const flowPolicies = await getWorkFlowAccessRights(flow.id);
            this.selectedRemoveFlowPolicy = flowPolicies.data;
            if (this.isWarningVisible) {
              break;
            }
          }
        }
      } catch (error) {
        this.selectedRemoveFlowPolicy = [];
      } finally {
        this.isLoading = false;
      }
    },
    onOpenItemView(itemId) {
      const routeData = this.$router.resolve({
        path: '/',
        query: {
          section: 'data',
          database: this.databaseName,
          item: itemId,
        },
      });
      window.open(routeData.href, '_blank');
    },
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    getWFlowWarningInfo() {
      const filterFlowPolicy = this.selectedRemoveFlowPolicy.filter(
        (policy) => policy.identity !== this.user.username
      );
      const isPublic = filterFlowPolicy.find(
        (policy) => policy.identity == 'public'
      );
      const isSharedWithOthers = isPublic
        ? filterFlowPolicy.length > 1
        : filterFlowPolicy.length;

      return { isSharedWithOthers, isPublic };
    },
    isWarningVisible() {
      return (
        this.resourceType === 'flow' &&
        this.actionType === 'remove' &&
        (this.getWFlowWarningInfo.isPublic ||
          this.getWFlowWarningInfo.isSharedWithOthers)
      );
    },
    getDeleteButtonText() {
      return this.actionType == 'leave'
        ? 'Verlassen'
        : this.resourceType == 'item'
        ? 'Endgültig löschen'
        : 'Löschen';
    },
  },
  created() {
    if (this.resourceType === 'flow' && this.actionType === 'remove') {
      this.getWorkflowPolicies();
    }
  },
  mounted() {
    if (this.resourceType === 'item' && this.actionType === 'remove') {
      if (this.name === 'Alle löschen') {
        this.text.item.remove.paragraph = `Gelöschte Einträge können nicht wiederhergestellt werden`;
        this.text.item.remove.description =
          this.itemsCount > 1
            ? `Bitte geben Sie <b>${this.name}</b> in das untenstehende Feld ein, um die ausgewählten Einträge zu löschen.`
            : `Bitte geben Sie <b>${this.name}</b> in das untenstehende Feld ein, um die ausgewählten Einträge zu löschen.`;
      }
    }
  },

  components: {
    CustomModal,
    CommonButton,
    LoadingSpinner,
  },
};
</script>

<style scoped>
.remove-confirm-modal .remove-confirm-modal-content-wrapper {
  min-height: 411px;
  max-width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-inline: 90px;
  width: 666px;
  text-align: start;
  padding-block: 64px;
  transition: height 0.3s ease-in-out;
}

.remove-confirm-modal .remove-confirm-modal-content-wrapper .content {
  width: 666px;
  max-width: 100%;
  height: fit-content;
}

.remove-confirm-modal .content-title {
  font-size: 20px;
  color: #333343;
  margin: 0;
  font-weight: 400;
  text-transform: uppercase;
}

.remove-confirm-modal .warning-message-container {
  margin-top: 19px;
  padding: 20px;
  border: 1px solid #d4d4d4;
  border-radius: 7px;
  height: auto;
  display: flex;
  flex-direction: column;
}
.remove-confirm-modal .content-paragraph {
  font-size: 16px;
  color: #333343;
  margin-bottom: 0;
  display: flex;
  align-items: center;
  gap: 16px;
}
.remove-confirm-modal .content-warning {
  margin-top: 10px;
}
.remove-confirm-modal .content-warning .public-warning,
.remove-confirm-modal .content-warning .shared-with-other-warning {
  font-size: 16px;
  color: #333343;
  margin-bottom: 0;
  display: flex;
  gap: 16px;
}

.remove-confirm-modal .content-warning .warning-icon {
  margin-top: 3px;
  margin-left: -2px;
  font-size: 14px;
}

.remove-confirm-modal .content-paragraph span {
  line-height: 0;
}
.remove-confirm-modal .content-paragraph .content-paragraph-text {
  line-height: 20px;
}
.remove-confirm-modal .content-paragraph span img {
  height: 14px;
}
.remove-confirm-modal .content-description {
  font-size: 16px;
  margin-top: 16px;
  margin-bottom: 22px;
  color: #333343;
}

.remove-confirm-modal .confirmation-message-input {
  outline: none;
  border: 0.5px solid #414143;
  border-radius: 4px;
  width: 100%;
  font-size: 16px;
  padding: 4px 16px;
  font-weight: 400;
  line-height: 20;
  height: 34px;
}

.remove-confirm-modal .confirmation-message-input::placeholder {
  color: rgba(51, 51, 67, 0.24);
}

.remove-confirm-modal .common-button-component {
  margin-top: 29px;
}

.remove-confirm-modal ::v-deep .loading-wrapper .progress-icon-wrapper {
  left: -67px;
}

@media (max-width: 767px) {
  .remove-confirm-modal .remove-confirm-modal-content-wrapper {
    padding-inline: 30px;
  }
}

@media (max-width: 500px) {
  .remove-confirm-modal .remove-confirm-modal-content-wrapper {
    min-height: 550px;
    padding-block: 50px;
  }
}

.remove-confirm-modal .pre-wrap ::v-deep b {
  white-space: pre-wrap;
  word-wrap: break-word;
}

.remove-confirm-modal .record-list {
  padding: 8px;
  margin: 12px 0;
}
.remove-confirm-modal .record-list h2 {
  font-size: 14px;
  font-weight: bolder;
  border-bottom: 1px solid #ccc;
  color: #333343;
}

.remove-confirm-modal .record-list ul {
  list-style: none;
  padding: 0;
  margin: 0;
  max-height: 105px;
  overflow-y: auto;
}

.remove-confirm-modal .record-list li {
  padding: 6px 8px;
  cursor: pointer;
  border-bottom: 1px solid #eee;
  display: flex;
  align-items: center;
  gap: 2px;
}

.remove-confirm-modal .record-list li:hover {
  background-color: #f5f5f5;
}
.remove-confirm-modal .record-list li img {
  width: 12px;
}
.remove-confirm-modal .record-list li img.link-icon {
  filter: invert(24%) sepia(96%) saturate(4888%) hue-rotate(205deg)
    brightness(99%) contrast(91%);
}
.remove-confirm-modal .record-list li span {
  font-size: 14px;
  margin-left: 4px;
  font-weight: 500;
  color: #0b6ada;
  text-decoration: underline;
  display: inline-block;
  max-width: 420px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
</style>
